import * as React from 'react'
import {withRouter} from "react-router-dom";
import { QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Popover } from 'antd';

class Cards extends React.Component {
  hdclick=()=>{
    this.props.history.push('/businessReport/orgReportM')
  };
  /** 提示文字：昨日新单量*/
  getNewBill = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">新单量：</p>
        <p className="desc">统计时间段内已支付出单件数-已撤单件数-已退保件数</p>
      </div>
    )
  }
  /** 提示文字：昨日保费*/
  getPolicy = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">保费：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费</p>
      </div>
    )
  };
  /** 提示文字：昨日推广费*/
  getPromotion = ()=>{
    return (
      <div className="homepage_question_tips">
        <p className="title">统计规则:</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队</p>

        <p className="title marTop24">推广费：</p>
        <p className="desc">统计时间段内已支付的获得-已撤单扣减-已退保扣减</p>
      </div>
    )
  };

  getTip(){
    return this.props.type === 1 ? this.getNewBill() : (this.props.type === 2 ? this.getPolicy() : this.getPromotion())
  }
  render () {
    return (
      <div className="rank_cards">
        <div className="container" onClick={()=>{this.hdclick()}}>
          <div style={{display:'flex',justifyContent: 'center'}}>
            <p className='title'>{this.props.title}</p>
            <Popover trigger='hover' placement="bottom"  content={this.getTip()}>
              <QuestionCircleOutlined style={{fontSize:'18px',marginTop:'10px',zIndex:1000}} />
            </Popover>
          </div>
          <p className="count">
            <span>{this.props.count}</span>
          </p>
          <p className="time">
            统计昨日0点至24点的数据量
          </p>
          <RightOutlined className="icon_right" />
        </div>
      </div>
    );
  }
}

// export default Cards
export default withRouter(Cards)
